import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import useSEO from "../hooks/useSEO";

const CONTACT = {
  address: "7912 5th Avenue, Bayridge, Brooklyn 11209",
  email:   "sagarfashion777@gmail.com",
  phone:   "+1 (718) 630-1100",
  hours: [
    { day: "Monday – Friday", time: "11:00 AM – 6:00 PM" },
    { day: "Saturday & Sunday", time: "11:00 AM – 7:00 PM" },
  ],
  socials: [
    {
      name: "Facebook",
      url:  "https://www.facebook.com/share/XUXiUxa45dz42kNX/",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
    },
    {
      name: "Instagram",
      url:  "https://www.instagram.com/sagarfashionnyc?igsh=N2JoeWlkcGpnODE=",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
        </svg>
      ),
    },
  ],
  mapUrl: "https://maps.google.com/maps?q=7912%205th%20Avenue,%20Bayridge,%20Brooklyn%2011209&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export default function Contact() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const seo = useSEO("contact");

  return (
    <div className="pt-20 min-h-screen bg-stone-50">
        <Helmet>
            <title>{seo?.title || "Contact Us — Sagar Fashion"}</title>
            <meta name="description" content={seo?.description || "Get in touch with Sagar Fashion."} />
            <meta name="keywords"    content={seo?.keywords    || "contact, sagar fashion, brooklyn"} />
            <meta property="og:title"       content={seo?.og_title       || seo?.title || "Contact — Sagar Fashion"} />
            <meta property="og:description" content={seo?.og_description || seo?.description || ""} />
        </Helmet>

      {/* Hero */}
      <div className="relative overflow-hidden bg-stone-900 py-20 px-6">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&q=55')", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/80 to-stone-900/50" />
        <div className="relative max-w-4xl mx-auto text-center">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-rose-400 mb-3 block">Get In Touch</span>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Visit Our Boutique
          </h1>
          <p className="text-white/60 text-lg font-light max-w-xl mx-auto">
            Come experience Sagar Fashion in person at our Bay Ridge, Brooklyn location — or reach out online.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          {/* Map */}
          <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-stone-100">
            <div className="px-6 py-5 border-b border-stone-100">
              <h2 className="text-lg font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>Our Location</h2>
            </div>
            <iframe
              src={CONTACT.mapUrl}
              width="100%"
              height="420"
              style={{ border: 0 }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Sagar Fashion Location"
            />
          </div>

          {/* Details */}
          <div className="space-y-5">

            {/* Store Details */}
            <div className="bg-white rounded-3xl p-6 shadow-sm border border-stone-100">
              <h2 className="text-lg font-bold text-stone-900 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>Store Details</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-rose-500" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-stone-400 uppercase tracking-wider mb-0.5">Address</p>
                    <p className="text-stone-700 text-sm">{CONTACT.address}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-rose-500" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-stone-400 uppercase tracking-wider mb-0.5">Email</p>
                    <a href={`mailto:${CONTACT.email}`} className="text-rose-500 hover:text-rose-600 text-sm font-medium transition-colors">
                      {CONTACT.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-rose-500" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-stone-400 uppercase tracking-wider mb-0.5">Phone</p>
                    <a href={`tel:${CONTACT.phone}`} className="text-rose-500 hover:text-rose-600 text-sm font-medium transition-colors">
                      {CONTACT.phone}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Business Hours */}
            <div className="bg-white rounded-3xl p-6 shadow-sm border border-stone-100">
              <h2 className="text-lg font-bold text-stone-900 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>Business Hours</h2>
              <div className="space-y-3">
                {CONTACT.hours.map(({ day, time }) => (
                  <div key={day} className="flex items-center justify-between py-2.5 border-b border-stone-50 last:border-0">
                    <div className="flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-green-400" />
                      <span className="text-sm text-stone-600 font-medium">{day}</span>
                    </div>
                    <span className="text-sm font-semibold text-stone-900">{time}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Follow Us */}
            <div className="bg-white rounded-3xl p-6 shadow-sm border border-stone-100">
              <h2 className="text-lg font-bold text-stone-900 mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>Follow Us</h2>
              <div className="flex gap-4">
                {CONTACT.socials.map(social => (
                    <a key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2.5 px-5 py-2.5 rounded-full border border-stone-200 text-stone-600 hover:bg-rose-500 hover:text-white hover:border-rose-500 transition-all duration-300 text-sm font-semibold"
                  >
                    {social.icon}
                    {social.name}
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}